import * as React from "react";

function SvgPlayCircle(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" {...props}><path d="M16 29l12-9-12-9v18zm4-29C8.95 0 0 8.95 0 20s8.95 20 20 20 20-8.95 20-20S31.05 0 20 0zm0 36c-8.82 0-16-7.18-16-16S11.18 4 20 4s16 7.18 16 16-7.18 16-16 16z" /></svg>;
}

export default SvgPlayCircle;